import * as React from 'react';
import { Button, Grid, Typography, Hidden, Paper, CircularProgress } from '@material-ui/core';
import DoneIcon from '@material-ui/icons/Done'
import { roundedCorners } from '../../../QmoTheme';
import { renderSolrHighlightedResult } from '../../../Common/CommonFunctions';
import { OrderSheetItemData } from '../../../api/models/OrderSheetData';
import ProductProperties from '../ProductProperties/ProductProperties';
import { ANY_PROP_OPTION, PropertyFilter, CategoryFilter } from '../../../models/SearchFilter';
import { ProductProp } from '../../../models/ProductProp';
import { ProductProperty2ProductProp } from '../../reducers/ProductsSearchRdc';
import { ProductProperty } from '../../../api/models/ProductProperty';
import { containsSameProduct } from '../../../Auth/Common';
import QmoLoader from '../../../Common/QmoLoader';

type Props = {
    products: OrderSheetItemData[],
    orderProducts: OrderSheetItemData[],
    onProductAdd: (prod: OrderSheetItemData) => void,
    onProductPropertyChange: (prod: OrderSheetItemData) => void,
    isBusy: boolean,
    highlights: { [id: string]: string[] },
    searchValue: string,

    updateOrderSheetBusy: boolean,
    currentProductProperties: ProductProp[],
    appliedPropertyFilters: PropertyFilter[],
    replaceFilter: (categoryFilter?: CategoryFilter | null, propertyFilter?: PropertyFilter | null) => void,
}


class ProductsListSearch extends React.Component<Props> {

    renderProducts(products: OrderSheetItemData[]) {
        if (products.length === 0) return (<div style={{ padding: '15px' }}><Typography variant="h3" align="center">No products matching your search criteria!</Typography></div>)
        else return products.map((prod, i) => {
            let isInOrder = containsSameProduct(this.props.orderProducts, prod)
            return (
                <Grid alignContent="center" container key={i} alignItems="center">
                    <Grid item xs={12} sm={12}>
                        <Grid container alignItems="center" style={{ minHeight: "48px" }}>
                            <Grid item xs={8} sm={3} className="table-item">
                                <Typography variant="body1">{renderSolrHighlightedResult(this.props.searchValue, this.props.highlights[prod.catalogueProductId], prod.name)}</Typography>
                            </Grid>
                            <Grid item xs={4} sm={8} className="table-item">
                                <div style={{ textAlign: 'center' }}>
                                    <ProductProperties
                                        defaultValue={ANY_PROP_OPTION}
                                        replaceFilter2={(property: ProductProp) => {
                                            let prodImmut: OrderSheetItemData = JSON.parse(JSON.stringify(prod))
                                            prodImmut.selectedProperties = prodImmut.selectedProperties.filter(p => p.id !== property.id)

                                            if (property.propertyOptions[0].id !== ANY_PROP_OPTION) {
                                                prodImmut.selectedProperties.push(new ProductProperty(property.id, property.name, property.type, [{ id: property.propertyOptions[0].id, name: property.propertyOptions[0].value }]))
                                            }

                                            this.props.onProductPropertyChange(Object.assign({}, prodImmut))
                                        }}
                                        replaceFilter={(categoryFilter?: CategoryFilter | null, propertyFilter?: PropertyFilter | null) => {
                                            this.props.replaceFilter(categoryFilter, propertyFilter)
                                        }}
                                        //onChange={this.props.onProductPropertyChangeInternal}
                                        appliedPropertyFilters={(() => {
                                            let x = prod.selectedProperties.map(pp => ProductProperty2ProductProp(pp, null)).flatMap(p => p.propertyOptions)
                                            return x
                                        })()}
                                        properties={prod.availableProperties.map(pp => ProductProperty2ProductProp(pp, null))/*this.props.currentProductProperties*/}></ProductProperties>
                                </div>
                            </Grid>
                            <Grid item xs={4} sm={1} className="table-item" >
                                <div style={{ textAlign: 'right' }}>
                                    {isInOrder ?
                                        <Button style={{ minWidth: '70px' }} color="secondary" variant="text"><DoneIcon /></Button>
                                        :
                                        <>
                                            {this.props.updateOrderSheetBusy ?
                                                <span style={{ paddingRight: "22px" }}><CircularProgress size={30} /></span>
                                                :
                                                <Button style={{ minWidth: '70px' }} color="secondary" variant="text" onClick={
                                                    () => {
                                                        this.props.onProductAdd(prod)
                                                    }
                                                }> Add </Button>

                                            }
                                        </>
                                    }
                                </div>
                            </Grid>
                        </Grid>
                        <Hidden smUp>
                            <hr></hr>
                        </Hidden>
                    </Grid>
                </Grid>
            )
        })
    }


    renderForSearch(products: OrderSheetItemData[]) {
        return (
            <div>
                <Paper style={Object.assign({ padding: "14px" }, roundedCorners)}>
                    <Typography variant="h2">Products</Typography>
                    <Hidden only="xs">
                        <Grid container>
                            <Grid item xs={12} sm={12}>
                                <Grid container>
                                    <Grid item xs={6} sm={3}>
                                        <Typography variant="subtitle1">NAME</Typography>
                                    </Grid>
                                    <Grid item xs={6} sm={8}>
                                        <div style={{ textAlign: 'center' }}><Typography variant="subtitle1">PROPERTIES</Typography></div>
                                    </Grid>
                                    <Grid item xs={6} sm={1}>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Hidden>
                    {this.props.isBusy ?
                        <div style={{ textAlign: 'center' }} >
                            <QmoLoader qmoAnimation={true} />
                        </div>
                        :
                        this.renderProducts(products)
                    }
                </Paper>
            </div>
        )
    }

    render() {
        return (
            <div>
                {this.renderForSearch(this.props.products)}
            </div>
        );
    }
}

export default ProductsListSearch;